import { ContratoAutorizacao } from './../contrato-autorizacao/contrato-autorizacao.model';
import { PessoaEndereco } from '../pessoa/pessoa.model';

export class Contrato {
    Id: string;
    IdPessoa: number;  // Filial
    IdAssinante: number; /* para mockup armazenar somente assinante atual ao inves de AssinanteContrato */
    IdCobrancaTipo: number;
    IdMotivoCancelamento: number;
    IdBancoAgencia: number;
    IdClienteTipo: number;
    DescricaoContrato: string;
    DtCadastro: Date;
    DtInicioVigencia: Date;
    DiaVencimento: number;
    ValorAdesao: number;
    Observacao: string;
    SituacaoContrato: string;
    FaturamentoTipo: string;
    EstaEmProcesso: string;
    ContratoReserva: string;
    ProtocoloContrato: string;
    TAG: string;
    ID: string; //  Atributo utilizado somente no backend
    ContratoEnderecos: ContratoEndereco[] = [];
    ContratoPacotes: ContratoPacote[] = [];
    ContratoAutorizacao: ContratoAutorizacao[] = [];
}
/*
class AssinanteContrato {
    Id: string;
    IdAssinante: number;
    IdContrato: number;
    DtInicioValidade: Date;
    DtFimValidade: Date;
}
*/
class ContratoEndereco {
    Id: string;
    //IdContrato: number; /* para mockup armazenar os dados de endereco dentro do contrato */
    //IdPessoaEndereco: number; 
    PessoaEndereco: PessoaEndereco; /* para mockup armazenar os dados de endereco dentro do contrato */
    TipoEndereco: string; /* Residencial, Comercial, Cobranca, ... */
    constructor() {
        this.PessoaEndereco = new PessoaEndereco;
    }
}

class ContratoPacote {
    Id: string;
    //IdContrato: number; /* para mockup armazenar os dados de endereco dentro do contrato */
    IdProdutoPacote: number;
    IdPontoTipo: number;
    ValorContratoPacote: number;
    DtFimFidelidade: Date;
    DescricaoLocalizacao: string;
    SituacaoContratoPacote: string;
    ItemsContrato: ItemContrato[] = []; /* para mockup armazenar os dados de Items dentro do ContratoPacote */
}

export class ItemContrato {
    IdItemSerie: number;
}



// WEBPACK FOOTER //
// ./src/app/contrato/contrato.model.ts